import { Steps, Tabs } from 'antd';
import styled from 'styled-components';
import { COLOR } from '@styles/theme';

export const DetailPanel = styled.div`
  background: ${COLOR.white};
  border-radius: 6px;
  border: 1px solid ${COLOR.border};
  overflow: hidden;
`;

export const MainDetailPanel = styled(DetailPanel)`
  flex: 1;
  min-width: 0;
`;

export const SidebarDetailPanel = styled(DetailPanel)`
  flex: 0 0 360px;
  max-width: 400px;
  padding: 16px 20px 20px;
`;

export const SecondaryHeaderBar = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;

export const StepsCenter = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  max-width: 680px;
  width: max-content;
`;

export const InboundDetailSteps = styled(Steps)`
  font-size: 13px;

  .ant-steps-item {
    cursor: default;
    pointer-events: none;
  }

  .ant-steps-item-container {
    cursor: default;
    pointer-events: none;
  }

  .ant-steps-item-icon {
    width: 28px;
    height: 28px;
    line-height: 26px;
    font-size: 12px;
  }

  .ant-steps-item-title {
    font-size: 13px;
    line-height: 28px;

    &::after {
      top: 13px;
    }
  }

  &.ant-steps-horizontal:not(.ant-steps-label-vertical) .ant-steps-item-description {
    display: none;
  }
`;

export const InboundDetailMainTabs = styled(Tabs)`
  .ant-tabs-tab-active {
    border-inline-start: 3px solid ${COLOR.accent};
  }

  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${COLOR.accent};
    font-weight: 600;
  }

  .ant-tabs-ink-bar {
    display: none;
  }

  .ant-tabs-tab {
    padding-inline: 20px;
  }

  .ant-tabs-content-holder {
    padding: 0;
  }

  &.ant-tabs-left > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane {
    padding-inline: 0;
  }
`;

export const InboundDetailSidebarTabs = styled(Tabs)`
  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${COLOR.accent};
    font-weight: 600;
  }

  .ant-tabs-ink-bar {
    background: ${COLOR.accent};
    height: 3px;
  }
`;

/** Wraps Ant Table so row generics stay on Table, not on styled(). */
export const InboundDetailContentsTableWrap = styled.div`
  .ant-table-wrapper {
    margin: 0;
  }

  .ant-table-container {
    margin-inline: 0;
  }

  .ant-table-cell {
    padding-inline: 0;
  }

  .ant-table-thead > tr > th {
    padding-block: 12px;
    padding-inline: 0;
  }

  .ant-table-thead > tr > th:first-child,
  .ant-table-tbody > tr > td:first-child {
    padding-inline-start: 0;
  }

  .ant-table-tbody > tr > td {
    padding-block: 16px;
    padding-inline: 0;
    vertical-align: top;
  }
`;
